import { InAppKeyboardLayoutId } from '~/in-app-keyboard/types/inAppKeyboard.types'

// Every bootcamp input shows the math keyboard on all screen sizes; inputs
// without an assigned layout get the default DecimalNumbers layout.
export default function useInAppKeyboardLayout(keyboardLayoutId: InAppKeyboardLayoutId | null): InAppKeyboardLayoutId {
  return keyboardLayoutId ?? 'DecimalNumbers_keyboard'
}
